var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-order-header"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"status"},[_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回")]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-268880c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail-page/header.vue
// module id = null
// module chunks = 